import React from 'react';
import LandingStaticLayout from '@layouts/LandingStaticLayout';
import dynamic from 'next/dynamic';

const ViewPDF = dynamic(() => import('@components/Core/ViewPDF'), { ssr: false });

const ExecSummaryPage = () => {
  return (
    <div className="flex flex-col flex-grow max-w-screen overflow-x-auto">
      <ViewPDF src="/docs/exec-summary.pdf" />
    </div>
  );
};

ExecSummaryPage.getLayout = (page: any) => {
  return <LandingStaticLayout contentClassName="">{page}</LandingStaticLayout>;
};

export default ExecSummaryPage;
